export default function Loading() {
  return <div className="loading">Trwa przetwarzanie</div>;
}
